import { Field, FieldInputProps } from "formik";
import { FormControl, Input, FormErrorMessage } from "@chakra-ui/react";
import CommonLabel from "./CommonLabel";

interface CommonFormikInputProps {
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  [key: string]: any;
}

const CommonFormikInput: React.FC<CommonFormikInputProps> = ({
  name,
  label,
  placeholder,
  type = "text",
  ...rest
}) => (
  <Field name={name}>
    {({ field, form }: { field: FieldInputProps<any>; form: any }) => (
      <FormControl
        isInvalid={!!(form.touched[name] && form.errors[name])}
        mb={4}
      >
        <CommonLabel>{label}</CommonLabel>
        <Input
          {...field}
          type={type}
          placeholder={placeholder}
          height="52px"
          fontSize="14px"
          fontWeight={400}
          border="1px solid #CDD6DC"
          textColor="#5C6670"
          borderRadius="12px"
          {...rest}
        />
        <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
      </FormControl>
    )}
  </Field>
);

export default CommonFormikInput;
